// @flow
import * as React from 'react';
import { components, colors } from '@peachjar/components';

const { Modal } = components;
const { ButtonFlatLarge } = components.Buttons;

type Props = {|
  +closeModal: () => void,
|};

class LearnMoreModal extends React.Component<Props> {
  render() {
    const { closeModal } = this.props;
    return (
      <Modal width="sm" onBackdropClick={closeModal}>
        <Modal.Header color={colors.gold}>Assign Agreement</Modal.Header>
        <Modal.Body>
          <div className="pj-font-size-03 p-4">
            Select the Review & Sign button to open the agreement in Docusign.
            If you would like to assign the agreement to someone else, select
            the assign button instead.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonFlatLarge
            onClick={closeModal}
            data-testid="click-closeLearnMoreModal"
          >
            Done
          </ButtonFlatLarge>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default LearnMoreModal;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/modals/LearnMoreModal.jsx